import React from "react";
import { Mail, Phone, MapPin, Hash } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { AuthImage } from "./FileUpload";

export function MemberCardDialog({ member, onClose }) {
  if (!member) return null;
  const Row = ({ icon: Icon, label, value, href, testId }) => value ? (
    <div className="flex items-start gap-3 text-sm" data-testid={testId}><Icon size={16} className="mt-0.5 shrink-0 text-gold" />
      <div><p className="eyebrow text-[10px] text-muted-foreground">{label}</p>{href ? <a href={href} className="text-crimson underline">{value}</a> : <p>{value}</p>}</div></div>
  ) : null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="member-card-dialog">
        <DialogHeader><DialogTitle className="sr-only">Member details</DialogTitle></DialogHeader>
        <div className="flex items-center gap-4">
          <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-full bg-crimson text-2xl font-bold text-parchment">{member.photo_url ? <AuthImage src={member.photo_url} alt="" className="h-full w-full object-cover" /> : member.name?.[0]}</div>
          <div><h3 className="font-serif-display text-2xl font-bold text-crimson" data-testid="member-card-name">{member.name}</h3><p className="eyebrow text-gold">{member.lineage_status}{member.role && member.role !== "member" ? ` · ${member.role}` : ""}</p></div>
        </div>
        <div className="mt-2 space-y-3">
          <Row icon={Hash} label="Member ID" value={member.member_id} testId="member-card-id" />
          <Row icon={Phone} label="Phone" value={member.phone} href={member.phone ? `tel:${member.phone}` : null} testId="member-card-phone" />
          <Row icon={Mail} label="Email" value={member.email} href={member.email ? `mailto:${member.email}` : null} testId="member-card-email" />
          <Row icon={MapPin} label="Address" value={[member.address, member.address2, [member.city, member.state].filter(Boolean).join(", "), member.postal_code].filter((x) => (x || "").trim()).join(", ")} testId="member-card-address" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
